import { Play, Check } from "lucide-react";
import { SOUNDS, DEFAULT_AUDIO, previewSound, setAudioSelection } from "../lib/audio";
import { usePrefs, useSavePrefs } from "../lib/store";
import { Slider } from "./ui/slider";

export function SoundPicker({ dark = false }) {
  const { data: prefs } = usePrefs();
  const save = useSavePrefs();
  const audio = { ...DEFAULT_AUDIO, ...(prefs?.audio || {}) };
  const update = (p) => {
    const next = { ...audio, ...p };
    setAudioSelection(next);
    save.mutate({ audio: next });
  };
  const txt = dark ? "text-white" : "text-t-on";
  const sub = dark ? "text-white/70" : "text-t-muted";
  return (
    <div className="flex flex-col gap-3" data-testid="sound-picker">
      {SOUNDS.map((s) => {
        const on = audio.sound === s.id;
        return (
          <div key={s.id} className={`flex items-center gap-3 rounded-2xl border p-3 transition-colors ${on ? "border-t-brand bg-t-brand3/60" : dark ? "border-white/15" : "border-t-border"}`}>
            <button type="button" onClick={() => update({ sound: s.id })} data-testid={`sound-${s.id}`} className="flex-1 flex items-center gap-3 text-left">
              <span className={`w-6 h-6 rounded-full border-2 grid place-items-center ${on ? "bg-t-brand border-t-brand text-t-onbrand" : dark ? "border-white/40" : "border-t-border2"}`}>{on ? <Check size={13} strokeWidth={3} /> : null}</span>
              <span>
                <span className={`block font-semibold ${on && !dark ? "text-t-on" : txt}`}>{s.label}</span>
                <span className={`block text-[13px] ${sub}`}>{s.desc}</span>
              </span>
            </button>
            <button type="button" onClick={() => previewSound(s.id, audio.vol1)} data-testid={`sound-preview-${s.id}`} aria-label={`Preview ${s.label}`}
              className="w-10 h-10 rounded-full bg-t-brand2 text-t-brand grid place-items-center"><Play size={16} fill="currentColor" /></button>
          </div>
        );
      })}
      <label className={`text-sm font-medium mt-2 ${txt}`}>Tone volume</label>
      <Slider value={[audio.vol1]} min={0} max={1} step={0.05} onValueChange={([v]) => update({ vol1: v })} data-testid="tone-volume" />
      <label className={`text-sm font-medium mt-2 ${txt}`}>Guide voice volume</label>
      <Slider value={[audio.voiceVol]} min={0} max={1} step={0.05} onValueChange={([v]) => update({ voiceVol: v })} data-testid="voice-volume" />
    </div>
  );
}
